module.exports = __webpack_public_path__ + "static/media/icon_benefit_souvenir.3fc038c5.svg";